import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FaqSection = () => {
  const faqs = [{
    q: '¿Cómo recibo el Master Kit después de comprar?',
    a: 'En menos de 5 minutos de realizado el pago, recibís un email con el enlace de descarga de todos los archivos PDF. No necesitás crear cuenta ni usuario. Acceso inmediato y de por vida.'
  }, {
    q: '¿Para qué condición de salud sirve?',
    a: 'El Master Kit está diseñado para adultos mayores en general. El Módulo vip +150 ejercicios tiene 3 niveles de adaptación según el estado físico y cognitivo real de cada persona. El Módulo 3 cubre específicamente Alzheimer, Parkinson, Diabetes e Hipertensión.'
  }, {
    q: '¿Necesito ser médico o enfermero para usarlo?',
    a: 'No. Todo el material está escrito en lenguaje claro y accesible para familias y cuidadores sin formación médica. Si podés leer estas líneas, podés usar el Master Kit desde hoy mismo.'
  }, {
    q: '¿Los 3 bonos están incluidos siempre?',
    a: 'Sí. Los 3 bonos (Cocina Vital, Kit de Socialización y Checklist Hogar Seguro) están incluidos en todas las compras del Master Kit sin costo adicional y sin condiciones.'
  }, {
    q: '¿Funciona si el adulto mayor va a un centro de día o tiene cuidador externo?',
    a: 'Perfectamente. El material está diseñado para complementar cualquier tratamiento médico o programa de cuidado existente. Los cuidadores profesionales y los centros de día pueden usar el Módulo vip +150 ejercicios como base de su programación diaria.'
  }, {
    q: '¿Puedo imprimirlo?',
    a: 'Sí. Todo el material está optimizado para impresión en A4 con letra grande y legible. Podés imprimir todo, una parte o usarlo directamente desde la pantalla de tu tablet o computadora.'
  }, {
    q: '¿Es diferente a un libro de ejercicios para adultos mayores?',
    a: 'Totalmente diferente. No es solo un libro de ejercicios. Es un sistema integral de cuidado que combina estimulación cognitiva, movilidad física, registros de salud, nutrición, socialización y seguridad del hogar. Todo en un solo lugar. Diseñado específicamente para Argentina y LATAM en 2026.'
  }, {
    q: '¿Para qué edad de adulto mayor sirve exactamente?',
    a: 'El sistema está diseñado para adultos mayores de 60 a 90 años. El Módulo vip +150 ejercicios permite adaptarlo al estado físico y cognitivo real de cada persona, independientemente de la edad cronológica.'
  }, {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Tarjeta de crédito y débito, Mercado Pago, Ualá, Pago Fácil, Rapipago y transferencia bancaria. Para otros países de LATAM: PayPal y tarjeta internacional.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si no quedás satisfecho/a por cualquier motivo, te devolvemos el 100% del valor pagado. Sin formularios ni procesos complicados.'
  }, {
    q: '¿Es compatible con el tratamiento médico que ya sigue el adulto mayor?',
    a: 'Sí. El Master Kit es un material complementario al tratamiento médico, no un reemplazo. La Bitácora de Control 360 está diseñada específicamente para que el médico de cabecera tenga información precisa y organizada en cada consulta.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-66">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-67">
        <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-68">
          ❓ PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-2 md:space-y-4" data-id="element-69">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-familia-cyan bg-familia-card' : 'border-familia-cyan/25 bg-familia-bg'}`} data-id="element-70">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 md:px-6 py-3 md:py-5 text-left flex justify-between items-center gap-3" data-id="element-71">
                  <span className="font-bold text-[14px] sm:text-base" data-id="element-72">
                    {faq.q}
                  </span>
                  <span className={`text-familia-cyan text-2xl transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-45' : ''}`} data-id="element-73">
                    +
                  </span>
                </button>
                <AnimatePresence data-id="element-74">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-75">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 pt-2 text-familia-gray text-[14px] sm:text-base leading-relaxed border-t border-white/10" data-id="element-76">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};